import { render } from "./FeaturedPrograms.vue?vue&type=template&id=6f42af1c&scoped=true"
import script from "./FeaturedPrograms.vue?vue&type=script&lang=js"
export * from "./FeaturedPrograms.vue?vue&type=script&lang=js"

import "./FeaturedPrograms.vue?vue&type=style&index=0&id=6f42af1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f42af1c"]])

export default __exports__